// playground requires you to assign document definition to a variable called dd
export const convertToPDFBalanceSheet = ({ data, firm, dateFrom, dateTo }) => {
    var dd = {
        content: [
            { text: 'Balance Sheet', style: 'header' },
            {
                table: {
                    body: [
                        [
                            {
                                table: {
                                    body: [

                                    ]
                                }
                            }, {
                                table: {
                                    body: [

                                    ]
                                }
                            },],
                    ]
                }
            },


        ],
        styles: {
            header: {
                fontSize: 14,
                bold: true,
                color: "#160091",
                margin: [0, 0, 0, 10]
            },
            header1: {
                fontSize: 10,
                bold: false,
                color: "#0D47A1"
            },
            header2: {
                fontSize: 10,
                bold: true,
                color: "#160091"
            },
        }

    }
    let flag = 0;
    let tabFlag = 0;
    data.map((value,index) => {
        if(value == 'Assets') {
            tabFlag = 1;
        }
        if(!tabFlag){
            if(flag%2 == 0) {
                dd.content[1].table.body[0][0].table.body.push(
                    [
                        { text: data[index], style: "header1" },
                        { text: data[index+1], style: "header2" },
                    ]
                )
            }
        } else {
            if(flag%2 == 0) {
                dd.content[1].table.body[0][1].table.body.push(
                    [
                        { text: data[index], style: "header1" },
                        { text: data[index+1], style: "header2" },
                    ]
                )
            }
        }
        flag++;
    })
    return dd;
}


export const convertToPDFTradingAccount = ({ data, firm, dateFrom, dateTo }) => {
    var dd = {
        content: [
            { text: 'Trading Account', style: 'header' },
            {
                table: {
                    body: [
                        [
                            {
                                table: {
                                    body: [

                                    ]
                                }
                            }, {
                                table: {
                                    body: [

                                    ]
                                }
                            },],
                    ]
                }
            },


        ],
        styles: {
            header: {
                fontSize: 14,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            header1: {
                fontSize: 10,
                bold: false,
                color: "#0D47A1"
            },
            header2: {
                fontSize: 10,
                bold: true,
                color: "#160091"
            },
        }

    }
    let flag = 0;
    let tabFlag = 0;
    data.map((value,index) => {
        if(index !=0 && value == 'Particulars') {
            tabFlag = 1;
        }
        if(!tabFlag){
            if(flag%2 == 0) {
                dd.content[1].table.body[0][0].table.body.push(
                    [
                        { text: data[index], style: "header1" },
                        { text: data[index+1], style: "header2" },
                    ]
                )
            }
        } else {
            if(flag%2 == 0) {
                dd.content[1].table.body[0][1].table.body.push(
                    [
                        { text: data[index], style: "header1" },
                        { text: data[index+1], style: "header2" },
                    ]
                )
            }
        }
        flag++;
    })
    return dd;
}


export const convertToPDFProfitAndLoss = ({ data, firm, dateFrom, dateTo }) => {
    var dd = {
        content: [
            { text: 'Profit and Loss Account', style: 'header' },
            {
                table: {
                    body: [
                        [
                            {
                                table: {
                                    body: [

                                    ]
                                }
                            }, {
                                table: {
                                    body: [

                                    ]
                                }
                            },],
                    ]
                }
            },


        ],
        styles: {
            header: {
                fontSize: 14,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            header1: {
                fontSize: 10,
                bold: false,
                color: "#0D47A1"
            },
            header2: {
                fontSize: 10,
                bold: true,
                color: "#160091"
            },
        }

    }
    let flag = 0;
    let tabFlag = 0;
    data.map((value,index) => {
        if(index !=0 && value == 'Particulars') {
            tabFlag = 1;
        }
        if(!tabFlag){
            if(flag%2 == 0) {
                dd.content[1].table.body[0][0].table.body.push(
                    [
                        { text: data[index], style: "header1" },
                        { text: data[index+1], style: "header2" },
                    ]
                )
            }
        } else {
            if(flag%2 == 0) {
                dd.content[1].table.body[0][1].table.body.push(
                    [
                        { text: data[index], style: "header1" },
                        { text: data[index+1], style: "header2" },
                    ]
                )
            }
        }
        flag++;
    })
    return dd;
}

export const convertToPDFProprietor = ({ data, firm, dateFrom, dateTo }) => {
    var dd = {
        content: [
            { text: 'Proprietor Capital Account', style: 'header' },
            {
                table: {
                    body: [
                        [
                            {
                                table: {
                                    body: [

                                    ]
                                }
                            }, {
                                table: {
                                    body: [

                                    ]
                                }
                            },],
                    ]
                }
            },


        ],
        styles: {
            header: {
                fontSize: 14,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            header1: {
                fontSize: 10,
                bold: false,
                color: "#0D47A1"
            },
            header2: {
                fontSize: 10,
                bold: true,
                color: "#160091"
            },
        }

    }
    let flag = 0;
    let tabFlag = 0;
    data.map((value,index) => {
        if(index !=0 && value == 'Particulars') {
            tabFlag = 1;
        }
        if(!tabFlag){
            if(flag%2 == 0) {
                dd.content[1].table.body[0][0].table.body.push(
                    [
                        { text: data[index], style: "header1" },
                        { text: data[index+1], style: "header2" },
                    ]
                )
            }
        } else {
            if(flag%2 == 0) {
                dd.content[1].table.body[0][1].table.body.push(
                    [
                        { text: data[index], style: "header1" },
                        { text: data[index+1], style: "header2" },
                    ]
                )
            }
        }
        flag++;
    })
    return dd;
}

export const convertToCashBook = ({ data, firm, dateFrom, dateTo }) => {
    var dd = {
        content: [
            { text: 'Cash Book', style: 'header' },
            {
                table: {
                    body: [
                        [
                            {
                                table: {
                                    body: [

                                    ]
                                }
                            }, {
                                table: {
                                    body: [

                                    ]
                                }
                            },],
                    ]
                }
            },


        ],
        styles: {
            header: {
                fontSize: 14,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            header1: {
                fontSize: 10,
                bold: false,
                color: "#0D47A1"
            },
            header2: {
                fontSize: 10,
                bold: true,
                color: "#160091"
            },
        }

    }
    let flag = 0;
    let tabFlag = 0;
    data.map((value,index) => {
        if(index !=0 && value == 'Particulars') {
            tabFlag = 1;
        }
        if(!tabFlag){
            if(flag%2 == 0) {
                dd.content[1].table.body[0][0].table.body.push(
                    [
                        { text: data[index], style: "header1" },
                        { text: data[index+1], style: "header2" },
                    ]
                )
            }
        } else {
            if(flag%2 == 0) {
                dd.content[1].table.body[0][1].table.body.push(
                    [
                        { text: data[index], style: "header1" },
                        { text: data[index+1], style: "header2" },
                    ]
                )
            }
        }
        flag++;
    })
    return dd;
}


// WEBPACK FOOTER //
// ./src/utils/pdf-reports/information-reports.js